import * as tslib_1 from "tslib";
var Cursor = (function () {
    function Cursor() {
    }
    Cursor.prototype.set = function (newValue) {
        throw new Error('immutable');
    };
    Cursor.prototype.delete = function () {
        throw new Error('immutable');
    };
    Cursor.Empty = undefined;
    return Cursor;
}());
export { Cursor };
var EmptyCursor = (function (_super) {
    tslib_1.__extends(EmptyCursor, _super);
    function EmptyCursor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyCursor.prototype.isEmpty = function () {
        return true;
    };
    EmptyCursor.prototype.head = function () {
        throw new Error('empty head');
    };
    EmptyCursor.prototype.step = function () {
        throw new Error('empty step');
    };
    EmptyCursor.prototype.skip = function (count) {
    };
    EmptyCursor.prototype.hasNext = function () {
        return false;
    };
    EmptyCursor.prototype.nextIndex = function () {
        return 0;
    };
    EmptyCursor.prototype.next = function () {
        return { done: true };
    };
    EmptyCursor.prototype.hasPrevious = function () {
        return false;
    };
    EmptyCursor.prototype.previousIndex = function () {
        return -1;
    };
    EmptyCursor.prototype.previous = function () {
        return { done: true };
    };
    return EmptyCursor;
}(Cursor));
Cursor.Empty = new EmptyCursor();
var UnitCursor = (function (_super) {
    tslib_1.__extends(UnitCursor, _super);
    function UnitCursor(value) {
        var _this = _super.call(this) || this;
        _this._value = value;
        _this._index = 0;
        return _this;
    }
    UnitCursor.prototype.isEmpty = function () {
        return this._index !== 0;
    };
    UnitCursor.prototype.head = function () {
        if (this._index === 0) {
            return this._value;
        }
        else {
            throw new Error('empty head');
        }
    };
    UnitCursor.prototype.step = function () {
        if (this._index === 0) {
            this._index = 1;
        }
        else {
            throw new Error('empty step');
        }
    };
    UnitCursor.prototype.skip = function (count) {
        this._index = Math.min(Math.max(0, this._index + count), 1);
    };
    UnitCursor.prototype.hasNext = function () {
        return this._index === 0;
    };
    UnitCursor.prototype.nextIndex = function () {
        return this._index;
    };
    UnitCursor.prototype.next = function () {
        if (this._index === 0) {
            this._index = 1;
            return { value: this._value, done: true };
        }
        else {
            return { done: true };
        }
    };
    UnitCursor.prototype.hasPrevious = function () {
        return this._index === 1;
    };
    UnitCursor.prototype.previousIndex = function () {
        return this._index - 1;
    };
    UnitCursor.prototype.previous = function () {
        if (this._index === 1) {
            this._index = 0;
            return { value: this._value, done: true };
        }
        else {
            return { done: true };
        }
    };
    return UnitCursor;
}(Cursor));
export { UnitCursor };
var KeyCursor = (function (_super) {
    tslib_1.__extends(KeyCursor, _super);
    function KeyCursor(cursor) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        return _this;
    }
    KeyCursor.prototype.isEmpty = function () {
        return this.cursor.isEmpty();
    };
    KeyCursor.prototype.head = function () {
        return this.cursor.head()[0];
    };
    KeyCursor.prototype.step = function () {
        this.cursor.step();
    };
    KeyCursor.prototype.skip = function (count) {
        this.cursor.skip(count);
    };
    KeyCursor.prototype.hasNext = function () {
        return this.cursor.hasNext();
    };
    KeyCursor.prototype.nextIndex = function () {
        return this.cursor.nextIndex();
    };
    KeyCursor.prototype.next = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value[0], done: done };
    };
    KeyCursor.prototype.hasPrevious = function () {
        return this.cursor.hasPrevious();
    };
    KeyCursor.prototype.previousIndex = function () {
        return this.cursor.previousIndex();
    };
    KeyCursor.prototype.previous = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value[0], done: done };
    };
    KeyCursor.prototype.delete = function () {
        this.cursor.delete();
    };
    return KeyCursor;
}(Cursor));
export { KeyCursor };
var ValueCursor = (function (_super) {
    tslib_1.__extends(ValueCursor, _super);
    function ValueCursor(cursor) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        return _this;
    }
    ValueCursor.prototype.isEmpty = function () {
        return this.cursor.isEmpty();
    };
    ValueCursor.prototype.head = function () {
        return this.cursor.head()[1];
    };
    ValueCursor.prototype.step = function () {
        this.cursor.step();
    };
    ValueCursor.prototype.skip = function (count) {
        this.cursor.skip(count);
    };
    ValueCursor.prototype.hasNext = function () {
        return this.cursor.hasNext();
    };
    ValueCursor.prototype.nextIndex = function () {
        return this.cursor.nextIndex();
    };
    ValueCursor.prototype.next = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value[1], done: done };
    };
    ValueCursor.prototype.hasPrevious = function () {
        return this.cursor.hasPrevious();
    };
    ValueCursor.prototype.previousIndex = function () {
        return this.cursor.previousIndex();
    };
    ValueCursor.prototype.previous = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value[1], done: done };
    };
    ValueCursor.prototype.delete = function () {
        this.cursor.delete();
    };
    return ValueCursor;
}(Cursor));
export { ValueCursor };
var LeafCursor = (function (_super) {
    tslib_1.__extends(LeafCursor, _super);
    function LeafCursor(_array, index) {
        if (index === void 0) { index = 0; }
        var _this = _super.call(this) || this;
        _this._array = _array;
        _this._index = index;
        return _this;
    }
    LeafCursor.prototype.isEmpty = function () {
        return this._index >= this._array.length;
    };
    LeafCursor.prototype.head = function () {
        if (this._index < this._array.length) {
            return this._array[this._index];
        }
        else {
            throw new Error('empty head');
        }
    };
    LeafCursor.prototype.step = function () {
        if (this._index < this._array.length) {
            this._index = 1;
        }
        else {
            throw new Error('empty step');
        }
    };
    LeafCursor.prototype.skip = function (count) {
        this._index = Math.min(this._index + count, this._array.length);
    };
    LeafCursor.prototype.hasNext = function () {
        return this._index < this._array.length;
    };
    LeafCursor.prototype.nextIndex = function () {
        return this._index;
    };
    LeafCursor.prototype.next = function () {
        var index = this._index;
        if (index < this._array.length) {
            this._index = index + 1;
            return { value: this._array[index], done: this._index === this._array.length };
        }
        else {
            this._index = this._array.length;
            return { done: true };
        }
    };
    LeafCursor.prototype.hasPrevious = function () {
        return this._index > 0;
    };
    LeafCursor.prototype.previousIndex = function () {
        return this._index - 1;
    };
    LeafCursor.prototype.previous = function () {
        var index = this._index - 1;
        if (index >= 0) {
            this._index = index;
            return { value: this._array[index], done: index === 0 };
        }
        else {
            this._index = 0;
            return { done: true };
        }
    };
    return LeafCursor;
}(Cursor));
export { LeafCursor };
var NodeCursor = (function (_super) {
    tslib_1.__extends(NodeCursor, _super);
    function NodeCursor(pages, index, pageIndex, _subCursor) {
        if (index === void 0) { index = 0; }
        if (pageIndex === void 0) { pageIndex = 0; }
        var _this = _super.call(this) || this;
        _this.pages = pages;
        _this._index = index;
        _this._pageIndex = pageIndex;
        _this._subCursor = _subCursor;
        return _this;
    }
    NodeCursor.prototype.isEmpty = function () {
        do {
            if (this._subCursor) {
                if (!this._subCursor.isEmpty()) {
                    return false;
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else if (this._pageIndex < this.pages.length) {
                this._subCursor = this.pageCursor(this.pages[this._pageIndex]);
                this._pageIndex += 1;
            }
            else {
                this._pageIndex = this.pages.length;
                return true;
            }
        } while (true);
    };
    NodeCursor.prototype.head = function () {
        do {
            if (this._subCursor) {
                if (!this._subCursor.isEmpty()) {
                    return this._subCursor.head();
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else {
                if (this._pageIndex < this.pages.length) {
                    this._subCursor = this.pageCursor(this.pages[this._pageIndex]);
                    this._pageIndex += 1;
                }
                else {
                    this._pageIndex = this.pages.length;
                    throw new Error('empty head');
                }
            }
        } while (true);
    };
    NodeCursor.prototype.step = function () {
        do {
            if (this._subCursor) {
                if (!this._subCursor.isEmpty()) {
                    this._index += 1;
                    return;
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else {
                if (this._pageIndex < this.pages.length) {
                    this._subCursor = this.pageCursor(this.pages[this._pageIndex]);
                    this._pageIndex += 1;
                }
                else {
                    this._pageIndex = this.pages.length;
                    throw new Error('empty step');
                }
            }
        } while (true);
    };
    NodeCursor.prototype.skip = function (count) {
        while (count > 0) {
            if (this._subCursor) {
                if (this._subCursor.hasNext()) {
                    this._index += 1;
                    count -= 1;
                    this._subCursor.next();
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else if (this._pageIndex < this.pages.length) {
                var subPage = this.pages[this._pageIndex];
                var subPageSize = this.pageSize(subPage);
                this._pageIndex += 1;
                if (subPageSize < count) {
                    this._subCursor = this.pageCursor(subPage);
                    if (count > 0) {
                        this._index += count;
                        this._subCursor.skip(count);
                        count = 0;
                    }
                    break;
                }
                else {
                    this._index += subPageSize;
                    count -= subPageSize;
                }
            }
            else {
                break;
            }
        }
    };
    NodeCursor.prototype.hasNext = function () {
        do {
            if (this._subCursor) {
                if (this._subCursor.hasNext()) {
                    return true;
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else if (this._pageIndex < this.pages.length) {
                this._subCursor = this.pageCursor(this.pages[this._pageIndex]);
                this._pageIndex += 1;
            }
            else {
                this._pageIndex = this.pages.length;
                return false;
            }
        } while (true);
    };
    NodeCursor.prototype.nextIndex = function () {
        return this._index;
    };
    NodeCursor.prototype.next = function () {
        do {
            if (this._subCursor) {
                if (this._subCursor.hasNext()) {
                    this._index += 1;
                    return this._subCursor.next();
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else {
                if (this._pageIndex < this.pages.length) {
                    this._subCursor = this.pageCursor(this.pages[this._pageIndex]);
                    this._pageIndex += 1;
                }
                else {
                    this._pageIndex = this.pages.length;
                    return { done: true };
                }
            }
        } while (true);
    };
    NodeCursor.prototype.hasPrevious = function () {
        do {
            if (this._subCursor) {
                if (this._subCursor.hasPrevious()) {
                    return true;
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else if (this._pageIndex > 0) {
                this._subCursor = this.reversePageCursor(this.pages[this._pageIndex - 1]);
                this._pageIndex -= 1;
            }
            else {
                this._pageIndex = 0;
                return false;
            }
        } while (true);
    };
    NodeCursor.prototype.previousIndex = function () {
        return this._index - 1;
    };
    NodeCursor.prototype.previous = function () {
        do {
            if (this._subCursor) {
                if (this._subCursor.hasPrevious()) {
                    this._index -= 1;
                    return this._subCursor.previous();
                }
                else {
                    this._subCursor = undefined;
                }
            }
            else if (this._pageIndex > 0) {
                this._subCursor = this.reversePageCursor(this.pages[this._pageIndex - 1]);
                this._pageIndex -= 1;
            }
            else {
                this._pageIndex = 0;
                return { done: true };
            }
        } while (true);
    };
    NodeCursor.prototype.set = function (newValue) {
        this._subCursor.set(newValue);
    };
    NodeCursor.prototype.delete = function () {
        this._subCursor.delete();
    };
    return NodeCursor;
}(Cursor));
export { NodeCursor };
//# sourceMappingURL=data:application/json;base64,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